// src/utils/validateConfig.js
export const validateAIConfig = () => {
  const apiKey = process.env.REACT_DO_API_KEY || process.env.REACT_APP_DO_API_KEY;
  
  if (!apiKey) {
    console.warn('⚠️ REACT_DO_API_KEY is not set in environment variables');
    return false;
  }
  
  if (!apiKey.startsWith('sk-do-')) {
    console.warn('⚠️ REACT_DO_API_KEY does not appear to be a valid DigitalOcean API key');
    return false;
  }
  
  console.log('✅ AI configuration validated');
  return true;
};